import "./styles/main.scss";
import Header from "Dashboard/components/Header";
import Toolbox from "./scenes/Main/components/Toolbox";
import BottomSection from "./scenes/Carnets/components/BottomSection";
import TopSection from "./scenes/Main/components/TopSection";
import { useProjectOptions } from "Dashboard/hooks/ProjectsOptions";

const Carnets = () => {
  const options = useProjectOptions({ showHiddenInDropDowns: false });

  return (
    <>
      <Header title="Karneti" />
      <Toolbox />
      <main id="karnet">
        <TopSection projects={options} />
        <BottomSection projects={options} />
      </main>
    </>
  );
};

export default Carnets;
